import { faCircleInfo, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'

const Tooltip = ({ children, ...props }) => {
  const [visible, setVisible] = useState(false)
  const [clickLocked, setClickLocked] = useState(false)
  const tooltipId = `tooltip-${Math.random().toString(36).substr(2, 9)}`

  // handlers to show and hide the tooltip
  const showTooltip = () => {
    if (!clickLocked) setVisible(true)
  }

  const hideTooltip = () => {
    if (!clickLocked) setVisible(false)
  }

  // handler for click toggle
  const toggleTooltip = () => {
    if (clickLocked) {
      setClickLocked(false)
      setVisible(false)
    } else {
      setClickLocked(true)
      setVisible(true)
    }
  }

  return (
    <div className="relative inline-block" {...props}>
      <FontAwesomeIcon
        icon={faCircleInfo}
        className="text-neutral-900 dark:text-neutral-100 cursor-pointer"
        aria-hidden={false}
        onMouseEnter={showTooltip}
        onFocus={showTooltip}
        onMouseLeave={hideTooltip}
        onBlur={hideTooltip}
        onClick={toggleTooltip}
        aria-describedby={tooltipId}
        tabIndex={0}
      />

      {visible && (
        <div
          id={tooltipId}
          role="tooltip"
          className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 p-4 w-96 bg-white/95 dark:bg-black/95 text-neutral-900 dark:text-neutral-100 text-sm rounded z-10 border dark:border-neutral-600 shadow"
        >
          {clickLocked && (
            <button className="button-x" onClick={toggleTooltip}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
          <p className="text-sm">{children}</p>
        </div>
      )}
    </div>
  )
}

export default Tooltip
